import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { resetStoreHeaderCompanyAnalysis } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import DetailTemplateService from './service'

export const searchCompanyThunk = createAsyncThunk(
  'dynamicReport/detailTemplate/searchCompany',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DetailTemplateService.searchCompany(data)
      if (response.success) {
        return response.data || []
      }
      return rejectWithValue(false)
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue(true)
      }
      return rejectWithValue(false)
    }
  },
)

export const getTemplateThunk = createAsyncThunk(
  'dynamicReport/detailTemplate/getTemplate',
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(resetStoreHeaderCompanyAnalysis())
    const response = await DetailTemplateService.getTemplate(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue()
  },
)

export const getIndicators = createAsyncThunk(
  'dynamicReport/detailTemplate/getIndicators',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DetailTemplateService.getIndicators(data)
      if (response.success) {
        return response.data || []
      }
      return rejectWithValue(false)
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue(true)
      }
      return rejectWithValue(false)
    }
  },
)

export const getAllPortfolio = createAsyncThunk(
  'dynamicReport/detailTemplate/getAllPortfolio',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DetailTemplateService.getAllPortfolio(data)
      if (response.success) {
        return response.data || []
      }
      return rejectWithValue(false)
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue(true)
      }
      return rejectWithValue(false)
    }
  },
)
